import { render, staticRenderFns } from "./update.vue?vue&type=template&id=2331c6b5&scoped=true"
import script from "./update.js?vue&type=script&lang=js&external"
export * from "./update.js?vue&type=script&lang=js&external"
import style0 from "./update.vue?vue&type=style&index=0&id=2331c6b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2331c6b5",
  null
  
)

export default component.exports